"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./TakeAPicture.css");
var Button_1 = require("../Button/Button");
var TakeAPicture = /** @class */ (function (_super) {
    __extends(TakeAPicture, _super);
    function TakeAPicture(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isCameraOpened: false,
            isCameraSupported: true,
            isPictureTaken: false,
        };
        _this.takePicture = _this.takePicture.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.reOpenTheCamera = _this.reOpenTheCamera.bind(_this);
        _this.savePic = _this.savePic.bind(_this);
        _this.isIOSMobile = _this.isIOSMobile.bind(_this);
        _this.checkIfCameraSupported = _this.checkIfCameraSupported.bind(_this);
        _this.startTheVideo = _this.startTheVideo.bind(_this);
        _this.getVideoRef = _this.getVideoRef.bind(_this);
        _this.checkIfCameraSupported();
        return _this;
    }
    TakeAPicture.prototype.getVideoRef = function (video) {
        if (!video) {
            return;
        }
        this.video = video;
    };
    TakeAPicture.prototype.onClick = function (picture) {
        if (this.props.events && this.props.events.onClick) {
            this.props.events.onClick(picture);
        }
    };
    TakeAPicture.prototype.checkIfCameraSupported = function () {
        var _this = this;
        var videoConstraints = this.getVideoContraints();
        if (!navigator.mediaDevices.getUserMedia && !navigator.getUserMedia) {
            this.setState({ isCameraSupported: false });
        }
        // Get access to the camera
        navigator.mediaDevices.getUserMedia(videoConstraints)
            .then(function (stream) {
            _this.stream = stream;
        })
            .catch(function (err) {
            try {
                navigator.getUserMedia(videoConstraints, function (stream) {
                    _this.stream = stream;
                }, function () {
                    _this.setState({ isCameraSupported: false });
                });
            }
            catch (err) {
                _this.setState({ isCameraSupported: false });
            }
        });
    };
    TakeAPicture.prototype.getVideoContraints = function () {
        var constraints = {};
        if (navigator && navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints().facingMode) {
            // facingMode Supported.
            var advancedConstraints = {};
            advancedConstraints.facingMode = 'environment';
            constraints.video = advancedConstraints;
        }
        else {
            // facingMode not Supported.
            constraints.video = true;
        }
        return constraints;
    };
    TakeAPicture.prototype.startTheVideo = function () {
        this.video.srcObject = this.stream;
        this.video.style.display = 'block';
        this.video.play();
        this.setState({ isCameraOpened: true });
    };
    TakeAPicture.prototype.isIOSMobile = function () {
        return /iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    TakeAPicture.prototype.savePic = function (file) {
        var blob = file.target.files[0];
        this.onClick(blob);
    };
    TakeAPicture.prototype.takePicture = function () {
        var _this = this;
        var canvas = document.createElement('canvas');
        canvas.height = 300;
        canvas.width = 300;
        var context = canvas.getContext('2d');
        context.drawImage(this.video, 0, 0, 300, 300);
        canvas.toBlob(function (result) {
            _this.onClick(result);
        });
        this.video.pause();
        this.setState({ isCameraOpened: false, isPictureTaken: true });
    };
    TakeAPicture.prototype.reOpenTheCamera = function () {
        this.video.play();
        this.setState({ isCameraOpened: true });
    };
    TakeAPicture.prototype.renderVideoUsingInputFile = function () {
        return (React.createElement("div", null,
            React.createElement("label", { htmlFor: "uploadFileInput", className: styles.inputFileLabel }, "Open Camera"),
            React.createElement("input", { id: "uploadFileInput", type: "file", accept: "image/*", capture: "environment", onChange: this.savePic, className: styles.uploadFileButton })));
    };
    TakeAPicture.prototype.renderVideoWithButton = function () {
        return (React.createElement("div", null,
            React.createElement(Button_1.default, { data: { text: 'Open Camera' }, events: { onClick: this.startTheVideo } }),
            React.createElement("video", { controls: false, width: "300", height: "300", className: styles.video, ref: this.getVideoRef }),
            this.state.isCameraOpened &&
                React.createElement(Button_1.default, { data: { text: 'Take Picture' }, events: { onClick: this.takePicture } }),
            !this.state.isCameraOpened && this.state.isPictureTaken &&
                React.createElement(Button_1.default, { data: { text: 'ReTake Picture' }, events: { onClick: this.reOpenTheCamera } })));
    };
    TakeAPicture.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.takeAPicture },
            (this.isIOSMobile() || !this.state.isCameraSupported) &&
                this.renderVideoUsingInputFile(),
            (!this.isIOSMobile() && this.state.isCameraSupported) &&
                this.renderVideoWithButton()));
    };
    return TakeAPicture;
}(React.Component));
exports.default = TakeAPicture;
//# sourceMappingURL=TakeAPicture.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TakeAPicture/TakeAPicture.js
// module id = 1276
// module chunks = 8